// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import { ListingKlarnaCalloutFields } from '@reverbdotcom/commons/src/gql/graphql';
import { RegionalKlarnaCallout } from './RegionalKlarnaCallout';

type Listing = ListingKlarnaCalloutFields.Fragment;

interface Props {
  listing: Listing;
}

export function ListingKlarnaCallout({ listing }: Props) {
  const subtotal = calculateSubtotal(listing);

  return (
    <RegionalKlarnaCallout
      amount={subtotal}
    />
  );
}

function calculateSubtotal(listing: Listing) {
  const amountCents = listing.pricing.buyerPrice.amountCents + (listing.shippingPrice?.amountCents || 0);

  return {
    amountCents,
    currency: listing.pricing.buyerPrice.currency,
  };
}

export const ListingKlarnaCalloutFragment = gql`
  fragment ListingKlarnaCalloutFields on Listing {
    _id
    id
    pricing {
      buyerPrice {
        amountCents
        currency
      }
    }
    shippingPrice {
      amountCents
    }
  }
`;
